module.exports = __webpack_public_path__ + "img/my-order.c0c27677.png";